import { cn } from '@/lib/utils';

interface Props {
  title: string;
  children: React.ReactNode;
  className?: string;
}

export function FilterSection({ title, children, className }: Props) {
  return (
    <section className={className}>
      <h4 className="text-[11px] uppercase tracking-[0.12em] font-semibold text-muted-foreground/90 mb-3">
        {title}
      </h4>
      {children}
    </section>
  );
}
